import A11yDialog from 'a11y-dialog'

document.querySelectorAll('.productModalContainer').forEach(function (container) {
    var id = container.getAttribute('id'); // make sure your modalContainer element has a unique ID
    var dialog = new A11yDialog(container);

    dialog.on('show', function (element, event) {
        document.body.classList.add('__modal');
    });

    dialog.on('hide', function (element, event) {
        document.body.classList.remove('__modal');
    });

    $('.productModalClose').click(function() {
        dialog.hide()
    })
});
